import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { WhatsAppConversation } from "../../aiConversations.types";
import {
  AiConversationSubRoute,
  ApiRoutesAiConversations
} from "../../constants/enums";

export const requestMarkReadConversation = async (
  conversationId: string
): Promise<WhatsAppConversation> => {
  return await instance.post(
    buildUrl(
      ApiRoutesAiConversations.Conversations,
      conversationId,
      AiConversationSubRoute.MarkRead
    )
  );
};
